export const escapeRegExp = (regexp) => regexp.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");